export default __webpack_public_path__ + "static/media/qidao.ad32b8c5.svg";